export default function truncateText(text, chars = 40) {
  if (!text) return "";
  return text.substring(0, chars) + "...";
}
